import { createAction } from 'redux-actions';

export const SELECT_CLASS = 'SELECT_CLASS';

const setSelectedClass = createAction(SELECT_CLASS);

export default {
    setSelectedClass
};



// WEBPACK FOOTER //
// ./containers/overview/selected-class-actions.js